/**
 * Admin V3 — Layout shell
 *
 * Used as the React Router layout wrapper around all admin-v3 routes.
 * Renders TopBar + Sidebar + main content area (Outlet). Wraps everything
 * in <ToastProvider> so any module can call useToast().
 *
 * Visual: slate-50 body background (legacy convention), sidebar on the
 * left, main content area with the rest of the width.
 */

import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ToastProvider } from '../shared/hooks/useToast';
import AdminV3TopBar from './AdminV3TopBar';
import AdminV3Sidebar from './AdminV3Sidebar';
import { DEFAULT_LOCALE } from '../i18n';

const AdminV3Shell = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <ToastProvider>
      {/* adminv3-scope: light shadcn theme vars; text-slate-900 gives ghost/outline
          buttons a readable default text colour (incident 2026-06-12 fix). The
          TopBar sets its own text-white, so the dark header is unaffected. */}
      <div className="adminv3-scope min-h-screen bg-slate-50 text-slate-900">
        <AdminV3TopBar
          userName={user?.name || user?.email}
          onLogout={handleLogout}
          locale={DEFAULT_LOCALE}
        />

        <div className="flex">
          <AdminV3Sidebar locale={DEFAULT_LOCALE} />

          <main className="flex-1 min-w-0 px-6 py-6">
            <Outlet />
          </main>
        </div>
      </div>
    </ToastProvider>
  );
};

export default AdminV3Shell;
